import { Model } from '@vuex-orm/core';
import STORE from '@/store/STORE';

const { name } = STORE.modules.trialHistory;

export default class TrialHistory extends Model {
  static entity = `${ name }`;

  static primaryKey = 'trial_id';

  static fields() {
    return {
      user: this.attr({}),
      role: this.attr(''),
      action: this.attr(''),
      status: this.attr(''),
      extra: this.attr({}),
      date_created: this.string(new Date().toISOString()),
    };
  }

  static methodConf = {
    http: {
      url: '',
    },
    methods: {
      $fetch: {
        name: 'fetch',
        http: {
          url: '/trials/:id/history',
          method: 'get',
        },
      },
    },
  };
}
